import { limit, orderBy } from "firebase/firestore";
import React, { useEffect } from "react";
import { Alert, Card, ListGroup } from "react-bootstrap";
import { useNavigate, useParams } from "react-router";

import { useFlightCollection } from "../../api/firestoreWrappers.generated.jsx";
import { Breadcrumbs, breadcrumbPaths } from "../../components/Breadcrumbs";
import FlightListItem from "../../components/FlightListItem";
import Layout, { Title } from "../../components/Layout/Layout";
import LoadMoreButton from "../../components/LoadMoreButton";
import TimeDisplay from "../../components/TimeDisplay/index.jsx";
import urls from "../../urls.jsx";

function FlightList(props) {
    return (
        <>
            {props.flights?.length === 0 && (
                <Alert variant="primary" className="mt-0 m-4">
                    No flights found
                </Alert>
            )}
            {props.flights.length > 0 && (
                <ListGroup variant="flush">
                    {props.flights.map((flight) => (
                        <FlightListItem
                            key={flight.id}
                            to={urls.flight(
                                props.organizationId,
                                props.locationId,
                                flight.id,
                            )}
                        >
                            Flight{" "}
                            <TimeDisplay
                                timestamp={flight?.timestamp?.seconds}
                                format="YYYY-MM-DD HH:mm:ss"
                                organizationId={props.organizationId}
                                locationId={props.locationId}
                            />
                            {` by ${flight?.drone?.id}`}
                        </FlightListItem>
                    ))}
                </ListGroup>
            )}
        </>
    );
}

export default function FlightListPage() {
    const { organizationId, locationId } = useParams();
    const navigate = useNavigate();
    const flightsPerPage = 50;

    const [flightsToLoad, setFlightsToLoad] = React.useState(flightsPerPage);
    const [flights, isLoading] = useFlightCollection(
        organizationId,
        locationId,
        [limit(flightsToLoad), orderBy("timestamp", "desc")],
    );

    useEffect(() => {
        if (!locationId || locationId === "undefined") {
            navigate(urls.locations(organizationId), { replace: true });
        }
    }, [locationId, organizationId, navigate]);

    return (
        <Layout>
            <title>Flights | MyCorvus</title>
            <Breadcrumbs path={breadcrumbPaths.flightList} />
            <Card>
                <Title
                    title={"Flights"}
                    backButtonUrl={urls.location(organizationId, locationId)}
                />
                <FlightList
                    organizationId={organizationId}
                    locationId={locationId}
                    flights={flights}
                />
            </Card>
            <LoadMoreButton
                disabled={false}
                isLoading={isLoading}
                load={() => {
                    setFlightsToLoad(flightsToLoad + flightsPerPage);
                }}
                showLoadAll={false}
                loadAll={() => {}}
                text={`Showing ${flights.length} flights`}
            />
        </Layout>
    );
}
